module.exports = __webpack_public_path__ + "media/assets/article-icon-1-16985e03f72f971cbf6881be0e982cb3b6b8a9bac8f3317c92d93abab6722759.png";